import { ResidentAppError } from '../../common/error'
import { ResidentAppErrorCode } from '../../common/types'

export const isFeatureAccessDenied = (error: unknown): boolean =>
  error instanceof ResidentAppError &&
  error.errorCode === ResidentAppErrorCode.FEATURE_ACCESS_DENIED
